export const SET_TOKEN = "SET_TOKEN"
export const REMOVE_TOKEN = "REMOVE_TOKEN"
export const SET_SNACKBAR = "SET_SNACKBAR"
export const SET_USER_INFO = "SET_USER_INFO"
export const REMOVE_USER_INFO = "REMOVE_USER_INFO"
export const SET_MODAL = "SET_MODAL"
export const SET_PRIMARY_COLOR = "SET_PRIMARY_COLOR"
export const REMOVE_PRIMARY_COLOR = "REMOVE_PRIMARY_COLOR"
